import { configureStore } from '@reduxjs/toolkit';
import { useDispatch, useSelector } from 'react-redux';
import { phoneCasesReducer } from './phoneCases/phoneCases.slices';
import { localCartReducer } from './localCart/localCart.slices';
import { tagsReducer } from './tags/tags.slices';
import { usersReducer } from './users/users.slices';
import { authReducer } from './auth/auth.slices';
import { notificationsReducer } from './notifications/notifications.slices';
import {
  notificationsMiddleware,
  updateCurrentUserDataMiddleware,
} from './middlewares';
import { localizationReducer } from './localization/localization.slices';

export const store = configureStore({
  reducer: {
    phoneCases: phoneCasesReducer,
    localCart: localCartReducer,
    tags: tagsReducer,
    users: usersReducer,
    auth: authReducer,
    notifications: notificationsReducer,
    localization: localizationReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: ['your/action/type'],
        // Ignore these field paths in all actions
        ignoredActionPaths: [
          'meta.arg',
          'payload.onSelect',
          'payload.onSuccess',
        ],
        // Ignore these paths in the state
        ignoredPaths: [],
      },
    }).concat(notificationsMiddleware, updateCurrentUserDataMiddleware),
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();
